import { useParams } from 'react-router-dom';
import { Box, styled } from '@mui/material';
import Home from './Home';
import Tokens from './Tokens';
import Support from './Support';
// import MyProgrammes from '../apps/programmes/MyProgrammes';
import ResourcesPage from './Resources';
import ProjectQuickLink from './ProjectQuickLink';
// import CarbonFootprintingNew from '../apps/carbonfootprinting/CarbonFootprintingNew';
import CarReporting from '../apps/tigercatburns/CarReporting';
import ProjectAssets from '../apps/tigercatburns/ProjectAssets';
import Users from '../apps/tigercatburns/Users';
import Operations from '../apps/tigercatburns/Operations';
import Factors from '../apps/tigercatburns/Factors';
import CarbonFootprinting from '../apps/carbonfootprinting/CarbonFootprinting';
import Programs from '../apps/rofburns/Programs';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

export default function MainLayout({ userType, userData, isOpen }) {
    const { page, projectId } = useParams();
    // const userData = useSelector(state => state.auth.userData);
    return (
        <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
            <DrawerHeader />
            {page === 'programs' ? (
                <Programs />
            ) : page === 'tokens' ? (
                <Tokens />
            ) : page === 'support-&-faqs' ? (
                // <MyProgrammes />
                <Support />
            ) : page === 'data-capturing' ? (
                // <CarbonFootprintingNew />
                <CarbonFootprinting variant={'data-capturing'} />
            ) : page === 'conversion-factors' ? (
                <CarbonFootprinting variant={'conversion-factors'} />
            ) : page === 'general-information' ? (
                <CarbonFootprinting variant={'general-information'} />
            ) : page === 'resources' ? (
                <ResourcesPage />
            ) : page === undefined && projectId ? (
                <ProjectQuickLink />
            ) : page === 'car-reporting' ? (
                <CarReporting userData={userData} />
            ) : page === 'project-assets' ? (
                <ProjectAssets userData={userData} />
            ) : page === 'users' && userData.isAdmin ? (
                <Users userType={userType} />
            ) : page === 'operations' ? (
                <Operations />
            ) : page === 'factors' ? (
                <Factors />
            ) : (
                <Home userType={userType} userData={userData} isOpen={isOpen} />
            )}
        </Box>
    );
}
